// extracted by mini-css-extract-plugin
export default {"BuildEditorInstructions":"webpack-concepts-Extraction-FormBuilder-BuildEditorInstructions-module__BuildEditorInstructions"};